export class Web {

  static init(settings) {
    this.settings = settings;
  }

  static getSetting(name) {
    return this.settings[name];
  }

  static getBaseURL() {
    return Web.getSetting('baseURL');
  }

  /**
   * Create a URL to the application. Will include the base URL.
   * Example:
   *   Web.createAppURL('/to/path/place')      // http://localhost:5000/to/path/place
   *   Web.createAppURL('to/path/place')       // http://localhost:5000/to/path/place
   *   Web.createAppURL('to', 'path', 'place') // http://localhost:5000/to/path/place
   */
  static createAppURL(...segments) {
    const baseUrl = Web.getBaseURL();
    const path = segments.join('/').replace(/^\/+/, '');
    return `${baseUrl}/${path}`;
  }
}

window.Web = Web;